const siteKey = process.env.VUE_APP_CATCHA_SITE_KEY

export default siteKey
